import { BookingSourceContainerComponent } from "@/lib/booking_source/container/component"
import { consumeLoading } from "@/lib/consume/loading"
import { consumeRouter } from "@/lib/consume/router"

export const BookingSourceContainerConsumer = consumeLoading(
  consumeRouter(BookingSourceContainerComponent)
)
